<template lang="pug">
.careimage-table-component.table-box.careimage-width
  .box-header.no-padding
    .messages.pull-left
      span.warning-message 介護記録の登録は非公開に変更してから行ってください。
    .buttons.float-right
      button#prev-week-btn.btn(@click="onPrevWeek()") ＜&nbsp;前の週
      button#today-btn.btn(@click="onToday()") 今日
      button#next-week-btn.btn(v-if="canOnNextWeek()" @click="onNextWeek()") 次の週&nbsp;＞
      button.btn.disable(v-else disabled) 次の週&nbsp;＞
  .box-body.no-padding
    .careimage-table-component
      // テーブル
      b-table(
        :items="careimageItems"
        :fields="careimageFields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filter-included-fields="filterFields"
        :busy="isLoading"
        sticky-header
        no-border-collapse
        table-class="basic-table"
        thead-tr-class="hidden-row"
        show-empty
        :filter-function="filterTable"
        @filtered="onFiltered"
      )
        // ローディング
        template(#table-busy)
          .text-center.table-loading-message
            b-spinner.spinner
            span.message.align-self-center 読込み中...
        // レコード無し
        template(#empty)
          .empty-message
            span 情報がありません
        // フィルター後レコード無し
        template(#emptyfiltered)
          .empty-message
            span 情報がありません

        // ヘッダー：表示対象のデータが存在する場合は列が3行なのでslotを使用してカスタマイズする
        template(#thead-top="data" v-if="careimageItems.length != 0")
          b-tr.date-header
            b-th.name-column 部屋名・利用者名
            b-th.date-column.careimage-date(v-for="[datetime, status] in Array.from(careimageStatusMap)" :key="datetime" :id="'id-' + datetime")
              span.date {{ formatCareimageDate(datetime) }}（
              span.week(:class="createWeekCssClass(datetime)") {{ getWeek(datetime) }}
              span ）
              b-popover(v-if="getHolidayName(datetime)" :target="'id-' + datetime" triggers="hover")
                span {{ getHolidayName(datetime) }}
          b-tr.public-status-header
            b-th.name-column
            b-th.date-column(v-for="[datetime, status] in Array.from(careimageStatusMap)" :key="datetime" :class="{ public: getIsPublic(datetime) }")
              PublicSwitch.mx-auto(:id="datetime" :value="getIsPublic(datetime)" @onSwitch="onChangePublicStatus(datetime)")
          b-tr.multiple-register-header
            b-th.name-column
            b-th.date-column(v-for="[datetime, status] in Array.from(careimageStatusMap)" :key="datetime" :class="{ public: getIsPublic(datetime) }")
              button.multiple-register-btn.btn.disable(v-if="getIsPublic(datetime) == true || rows == 0" disabled) 一括登録
              button.multiple-register-btn.btn(v-else @click="gotoMultipleRegister(status)") 一括登録
        // ヘッダー：表示対象のデータが存在しない場合は1行だけ表示する
        template(#thead-top="data" v-else)
          b-tr.date-header
            b-th.name-column 部屋名・利用者名
            b-th.date-column.careimage-date(v-for="n in 7" :key="n")

        // セル：部屋名・利用者名
        template(#cell(residentName)="row")
          .resident-name(:id="`resident-${row.item.id}`")
            .room-name {{ row.item.roomName }}
            .name {{ row.item.name }}
          b-popover(v-if="row.item.name" :target="`resident-${row.item.id}`" triggers="hover" :placement="'left'")
            .d-flex.flex-column
              div.font-weight-bold 利用者グループ
              div {{ row.item.groupName }}
              div.font-weight-bold 部屋名
              div {{ row.item.roomName }}
              div.font-weight-bold 利用者名
              div {{ row.item.name }}
        // セル：日付0
        template(#cell(column0)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime0) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime0) && getIsPublic(row.item.datetime0)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime0)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime0), row.item.name)"
            )
        // セル：日付1
        template(#cell(column1)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime1) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime1) && getIsPublic(row.item.datetime1)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime1)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime1), row.item.name)"
            )
        // セル：日付2
        template(#cell(column2)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime2) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime2) && getIsPublic(row.item.datetime2)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime2)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime2), row.item.name)"
            )
        // セル：日付3
        template(#cell(column3)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime3) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime3) && getIsPublic(row.item.datetime3)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime3)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime3), row.item.name)"
            )
        // セル：日付4
        template(#cell(column4)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime4) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime4) && getIsPublic(row.item.datetime4)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime4)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime4), row.item.name)"
            )
        // セル：日付5
        template(#cell(column5)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime5) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime5) && getIsPublic(row.item.datetime5)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime5)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime5), row.item.name)"
            )
        // セル：日付6
        template(#cell(column6)="row")
          .careimage-icon.d-flex.flex-row.justify-content-center.align-items-center(:class="{ public: getIsPublic(row.item.datetime6) }")
            img.disable-icon(v-if="isViewDisableIcon(row.item.careimages, row.item.datetime6) && getIsPublic(row.item.datetime6)" src="@/assets/careimage-register-disable.png")
            img.icon(v-else v-for="viewIcon in getViewIconList(row.item.careimages, row.item.datetime6)"
              :src="viewIcon" @click="onImageIcon(row.item.careimages.get(row.item.datetime6), row.item.name)"
            )
      .table-options.d-flex.flex-row.justify-content-end.align-items-center
        // フィルタリング
        span.table-option-text 利用者グループ:
        .filter
          b-form-select(
            id="filter-input"
            v-model="filter"
            :options="filterOptions"
            size="md"
          )
        // ページあたりの行数
        span.table-option-text 1ページの行数:
        .per-page
          b-form-select(
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="md"
            @change="selectPerPage"
          )
        // ページネーション
        b-pagination.m-0(
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          :disabled="isLoading"
          @change="selectPage"
          hide-goto-end-buttons
        )

  OkCancelModal(v-model="showUpdateModal" :title="changePublicModalMessage" @ok="changePublicStatus")

  CareimageModal(@on-delete="showDeleteConfirmModal" show-delete="true" ref="careimageModal")
  OkCancelModal(v-model="showDeleteModal" :title="deleteTargetString" @ok="deleteCareimage")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Watch, Vue } from "vue-property-decorator";
import { userStore, itemListFilterStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import { nationalHolidaysStore } from "@/store/store";
import { NationalHolidaysGetModel } from "@/commons/services/NationalHolidays";

import Setting from "../../../../public/setting.json";
import CareimageStatusModel from "@/commons/models/CareimageStatus";
import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";
import CareimagesService from "@/commons/services/Careimages";
import CareimageStatusesService from "@/commons/services/CareimageStatuses";
import S3UrlService from "@/commons/services/S3Url";
import CareimageModel from "@/commons/models/Careimage";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import CareimageModal from "@/pc/components/modals/CareimageModal.vue";
import PublicSwitch from "@/pc/basics/PublicSwitch.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";

/**
 * 介護記録テーブルコンポーネント
 */
@Component({
  components: {
    PublicSwitch,
    CareimageModal,
    OkCancelModal,
    PageLoading
  }
})
export default class CareimageTable extends Vue {
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 介護記録サービス */
  @Inject("CareimagesService") careimagesService!: CareimagesService;
  /** 介護記録公開状態サービス */
  @Inject("CareimageStatusesService") careimageStatusesService!: CareimageStatusesService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;

  /**
   * 利用者の絞り込み設定
   * true=家族がいる利用者のみ
   * false=全件取得
   */
  @Prop({
    default: () => {
      return false;
    }
  })
  existFamily!: boolean;

  @Prop()
  storeNameSuffix!: string;

  /** 祝日MAP */
  holidaysMap: Map<string, NationalHolidaysGetModel> = new Map();

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 削除確認モーダル表示可否 */
  showDeleteModal: boolean = false;

  /** 表示する介護記録の基準日。この基準日を更新することで画面の表示を切り替えていく */
  baseDate: Date = new Date();
  /** 介護記録列名 */
  careimageFields: Array<CareimageTableField> = [];
  /** 介護記録各行の情報 */
  careimageItems: Array<CareimageTableItem> = [];
  /** グループIDとグループ名のMAP */
  groupNameMap: Map<number, string> = new Map();
  /** 読込み中か否か */
  isLoading: boolean = true;
  /** フィルタリング条件 */
  filter: any = "";
  /** フィルター選択項目 */
  filterOptions: Array<{ value: string; text: string }> = [];
  /** フィルタリング対象カラム名 */
  filterFields: string[] = ["groupId"];
  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** 現在取得している件数 */
  currentRows: number = 0;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.careimage.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.careimage.pageOptions;
  /** 先行して取得するページ範囲 */
  pageRange: number = Setting.careimage.pageRange;

  /**
   * key: 曜日名
   * value: スタイルクラス名
   * 曜日毎に文字色を変えるために用いる
   */
  readonly Weeks: Map<string, string> = new Map([
    ["日", "sunday"],
    ["月", ""],
    ["火", ""],
    ["水", ""],
    ["木", ""],
    ["金", ""],
    ["土", "saturday"]
  ]);
  /** 1ページに表示する日数 */
  readonly ViewDayCount: number = 7;

  /** 介護記録公開設定のMap。key:日付、value:介護記録公開設定 */
  careimageStatusMap: Map<number, CareimageStatusModel> = new Map();
  /** 公開情報切り替え時のメッセージ */
  changePublicModalMessage: string = "";
  /** 削除確認モーダルに表示する削除対象の介護記録 */
  deleteTargetString: string = "";
  /** 削除対象の介護記録。モーダルを複数経由するので、保持する */
  deleteTargetCareimage: CareimageModel | any = {};
  /**
   * 公開/非公開の切替え対象の介護記録公開設定
   * 公開/非公開のスイッチボタン押下時に、スイッチボタンから
   * emitされた際に更新対象が分からなくなるため保持する
   */
  changeTargetCareimageStatus: CareimageStatusModel = {
    facilityId: 0,
    isPublic: false,
    datetime: 0
  };

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `careimage-list-${this.existFamily}-per-page=${perPage}; max-age=${saveSecond};`;

    return;
  }

  /**
   * vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.holidaysMap = this.createHolidaysMap(nationalHolidaysStore.holidays);

    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.careimage.perPage);

    // グループIDとグループ名の変換用にグループ情報のMAPを作る
    const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const groupNameMap: Map<number, string> = this.createGroupNameMap(groups);
    this.groupNameMap = groupNameMap;
    // フィルターの項目を作成する
    const filterOptions: Array<{ value: string; text: string }> = await this.createFilterOptions(groups);
    this.filterOptions = filterOptions;
    // フィルタの復元
    this.restoreFilterSetting();

    // 画面情報を作成する
    this.careimageItems = [];
    this.currentRows = this.careimageItems.length;

    this.createView();

    return;
  }

  public createHolidaysMap(holidays: Array<NationalHolidaysGetModel>): Map<string, NationalHolidaysGetModel> {
    const holidaysMap: Map<string, NationalHolidaysGetModel> = new Map();
    for (const holiday of holidays) {
      holidaysMap.set(holiday.date, holiday);
    }
    return holidaysMap;
  }

  /**
   * 画面情報を再作成する
   */
  public async refresh(): Promise<void> {
    this.careimageItems = [];
    this.currentRows = this.careimageItems.length;

    this.createView();

    return;
  }

  /**
   * 基準日付をもとに画面表示する介護記録を作成する
   * 画面に表示する介護記録は、基準日を含めるthis.ViewDayCount日分(基準日+基準日から前this.ViewDayCount-1日分)
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    // 表示対象は基準日-6日～基準日なので、toを基準日とする
    // 基準日より6日前のDateオブジェクトを作り、fromとする
    const to: number = this.$dateUtil.convertDateToNumber(this.baseDate, "yyyymmdd000000000");
    let fromDate: Date = new Date(this.baseDate.getTime());
    // 当日を含むので、ViewDayCount+1で計算する
    fromDate.setDate(fromDate.getDate() - this.ViewDayCount + 1);
    const from: number = this.$dateUtil.convertDateToNumber(fromDate, "yyyymmdd000000000");
    // 画面表示用にKey:日付, Value:介護記録公開設定のMapを作る
    this.careimageStatusMap = await this.getCareimageStatuses(from, to);

    // 列名の情報が無いとヘッダーが非表示にされてしまうので、列名を作成する。実際には列名はcssで非表示にする
    const careimageFields: Array<CareimageTableField> = this.createCareimageFields(this.careimageStatusMap);
    this.careimageFields = careimageFields;

    // 全体の行数を非同期で取得する
    this.setRows();

    // 表示対象の利用者を取得する
    const residents: Array<ResidentGetModel> = await this.getResidents();
    const careimageItems: Array<CareimageTableItem> = await this.createCareimageItems(residents, this.baseDate, from, to, this.groupNameMap);
    this.careimageItems = this.careimageItems.concat(careimageItems);
    this.currentRows = this.careimageItems.length;

    this.isLoading = false;

    return;
  }

  /**
   * 介護記録公開設定から、Key:日付, Value:介護記録公開設定のMapを作る
   *
   * @param from 始点の日付
   * @param to 終点の日付
   */
  public async getCareimageStatuses(from: number, to: number): Promise<Map<number, CareimageStatusModel>> {
    const params: any = {
      start: from,
      end: to
    };

    const response: Map<number, CareimageStatusModel> = await this.careimageStatusesService.get(userStore, params);

    return response;
  }

  /**
   * ### 介護記録の列名を作成する
   */
  public createCareimageFields(careimageStatusMap: Map<number, CareimageStatusModel>): Array<CareimageTableField> {
    let fields: Array<CareimageTableField> = [];

    // 部屋名・利用者名の部分を作る
    fields.push({ key: "residentName", label: "部屋名・利用者名", sortable: false, sortDirection: "desc", class: "name-column" });

    // 日付分の列名を作成する
    for (let i = 0; i < Array.from(careimageStatusMap).length; i++) {
      fields.push({ key: `column${i}`, label: "", sortable: false, sortDirection: "desc", class: "date-column text-center" });
    }

    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = cookieMap[`careimage-list-${this.existFamily}-per-page`];

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /**
   * ### 全ての利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### グループIDとグループ名のMAPを作成する
   */
  public createGroupNameMap(residentGroups: Array<ResidentGroupsGetModel>): Map<number, string> {
    let groupMap: Map<number, string> = new Map<number, string>();
    for (const group of residentGroups) {
      groupMap.set(group.id, group.name);
    }

    return groupMap;
  }

  /**
   * ### 利用者グループフィルター用選択項目
   *
   * - 検索用に利用者グループマスターのMAPを作る
   * - アカウント情報から許可されている利用者グループIDの配列を取得する
   * - 利用者グループマスターと照合して選択項目の利用者グループを作成する
   */
  public createFilterOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: string; text: string }> {
    const filterOptions: Array<{ value: string; text: string }> = [];

    filterOptions.push({
      value: "",
      text: "全て"
    });

    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (allowedGroupsMap.has(group.id)) {
        filterOptions.push({
          value: `${group.id}`,
          text: group.name
        });
      }
    }

    return filterOptions;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name + `-${this.storeNameSuffix}`] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name + `-${this.storeNameSuffix}`];
    }
    return;
  }

  /**
   * ページング用の全件数を設定する
   */
  public async setRows() {
    try {
      // APIの仕様は以下なので、全件取得の場合はパラメータ自体渡さない
      // true=家族がいる利用者のみ取得
      // false=家族がいない利用者のみ取得
      const params: any = {};
      if (this.existFamily) {
        params["existFamily"] = this.existFamily;
      }
      const count: number = await this.residentsService.getCount(userStore, params);
      this.rows = count;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * 利用者を取得する
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    const startIndex: number = this.currentRows;
    // tableのライブラリでソートやフィルタリング、ページングを管理するので表示対象のよりも多めに取得しておく
    const endIndex: number = this.perPage * (this.currentPage * this.pageRange);
    const params: any = {
      startIndex: startIndex,
      endIndex: endIndex
    };
    // APIの仕様は以下なので、全件取得の場合はパラメータ自体渡さない
    // true=家族がいる利用者のみ取得
    // false=家族がいない利用者のみ取得
    if (this.existFamily) {
      params["existFamily"] = this.existFamily;
    }

    const response: Array<ResidentGetModel> = await this.residentsService.gets(userStore, params);

    return response;
  }

  /**
   * 利用者情報とそれに紐づく介護記録をまとめたデータを作成する
   *
   * - TODO リファクタリング対象
   *
   * @param residents 介護記録を紐づける利用者情報
   * @param from 始点の日付
   * @param to 終点の日付
   */
  public async createCareimageItems(
    residents: Array<ResidentGetModel>,
    baseDate: Date,
    from: number,
    to: number,
    groupIdMap: Map<number, string>
  ): Promise<Array<CareimageTableItem>> {
    let careimageItems: Array<CareimageTableItem> = [];

    // 利用者毎に介護記録を取得する
    // 利用者毎に介護記録の取得を待機していると時間がかかるため、取得処理を並列で行う
    const results: Array<any> = await Promise.all(
      residents.map(async (resident) => {
        try {
          if (resident.id) {
            // 利用者にひもづく介護記録を期間指定で取得する
            const careimages: Array<CareimageModel> = await this.getCareimage(resident.id, from, to);

            const groupName: string | undefined = groupIdMap.get(resident.groupId);
            const residentCareimage: any = {
              id: resident.id,
              name: resident.name,
              roomName: resident.room,
              groupId: resident.groupId,
              groupName: groupName ? groupName : "",
              datetime0: 0,
              datetime1: 0,
              datetime2: 0,
              datetime3: 0,
              datetime4: 0,
              datetime5: 0,
              datetime6: 0,
              careimages: new Map<number, CareimageModel>()
            };

            // residentCareimagesに介護記録を格納する
            // 表示日付に該当する介護記録が存在しない場合は、id=0, imageUrls=空配列の介護記録を格納する
            // image_urlsが空配列のデータは画面上では存在しない扱いとする
            for (let i = 0; i < this.ViewDayCount; i++) {
              // 表示日付と同じ日付の介護記録を検索するための日時を作る
              let date: Date = new Date(baseDate.getTime());
              date.setDate(date.getDate() - i);
              const searchTarget: number = this.$dateUtil.convertDateToNumber(date, "yyyymmdd000000000");

              // 表示日付と同じ日付の介護記録を検索する
              const filterResult: Array<CareimageModel> = careimages.concat().filter((careimage: CareimageModel) => {
                if (searchTarget == careimage.datetime) {
                  return true;
                }
                return false;
              });

              // 同じ日付の介護記録がある場合、新しいレコードを優先する
              // 理由は画像の登録アップロードに失敗したなどして画面表示していない古いレコードを無視するため
              let latestCareimage: CareimageModel | undefined = undefined;
              if (Array.isArray(filterResult) && filterResult.length > 0) {
                latestCareimage = filterResult[filterResult.length - 1];
              }

              // 該当する介護記録があるかつ画像URLが存在している介護記録のみを画面表示対象とする
              let isPublic: boolean = false;
              let imageUrls: Array<string> = [];
              if (latestCareimage && latestCareimage.imageUrls) {
                for (let imageUrl of latestCareimage.imageUrls) {
                  imageUrls.push(imageUrl);
                }
                isPublic = latestCareimage.isPublic;
              }
              // 空データ扱いの介護記録は新規作成する必要があるため、一律に介護記録を画面表示用に作り直す
              const displayCareimage: CareimageModel = {
                datetime: searchTarget,
                imageUrls: imageUrls,
                isPublic: isPublic,
                residentId: resident.id,
                // 以下使用しないデータのため、型のデフォルト値で初期化
                facilityId: userStore.loginUser.facilityId,
                deleteFlag: false,
                residentName: resident.name,
                residentRoom: resident.room,
                writtenBy: "",
                writerId: ""
              };

              // TODO 将来リファクタリング対象
              // iはインクリメントしていくが、基準日はデクリメントしていく実装方法が良くない
              residentCareimage[`datetime${this.ViewDayCount - i - 1}`] = searchTarget;
              residentCareimage.careimages.set(searchTarget, displayCareimage);
            }

            careimageItems.push(residentCareimage);
          }
        } catch (error) {
          // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
          return error;
        }
      })
    );

    // 非同期処理中に例外が発生していればresultの中にSystemerrorが格納されているのでチェックする
    for (const result of results) {
      if (result) {
        // エラーハンドル処理を実行する
        errorHandle(result, this);
      }
    }

    const sortedCareimageItems: Array<CareimageTableItem> = this.sortResidentCareimages(careimageItems);

    return sortedCareimageItems;
  }

  /**
   * 介護記録取得
   *
   * @param residentId 介護記録に紐づく利用者ID
   * @param from 始点の日付
   * @param to 終点の日付
   */
  public async getCareimage(residentId: number, from: number, to: number): Promise<Array<CareimageModel>> {
    const params: any = {
      start: from,
      end: to
    };

    const response: Array<CareimageModel> = await this.careimagesService.get(userStore, params, residentId);

    return response;
  }

  /**
   * 利用者毎の介護記録を部屋名でソートする
   * 部屋名は重複がありえるため、先に利用者IDでソートする
   */
  public sortResidentCareimages(careimageItems: Array<CareimageTableItem>): Array<CareimageTableItem> {
    // 利用者IDでソート
    const idSortedResidents: Array<CareimageTableItem> = careimageItems.concat().sort((careimage1, careimage2) => {
      if (careimage1.id < careimage2.id) {
        return -1;
      }
      if (careimage1.id > careimage2.id) {
        return 1;
      }
      return 0;
    });

    // 部屋名でソート
    const sortedResidents: Array<CareimageTableItem> = idSortedResidents.concat().sort((careimage1, careimage2) => {
      if (careimage1.roomName < careimage2.roomName) {
        return -1;
      }
      if (careimage1.roomName > careimage2.roomName) {
        return 1;
      }
      return 0;
    });

    return sortedResidents;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    this.careimageItems = [];
    this.currentRows = this.careimageItems.length;
    await this.createView();

    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;

    // 初期表示時点では一定数しか情報を取得していないので、既に情報が取得されていなければ取得する
    const newPageRows = this.perPage * (this.currentPage - 1);
    if (this.currentRows <= newPageRows) {
      await this.createView();
    }

    return;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: CareimageTableItem): boolean {
    if (row.groupId == this.filter) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.rows = filteredItems.length;
    return;
  }

  /**
   * 介護記録公開設定MAPから、日付に応じた公開/非公開を返す
   *
   * @param datetime 公開/非公開が欲しい日付
   */
  public getIsPublic(datetime: number): boolean {
    const careimageStatus: CareimageStatusModel | undefined = this.careimageStatusMap.get(datetime);
    if (!careimageStatus) {
      return false;
    }

    return careimageStatus.isPublic;
  }

  /**
   * 次の週ボタンが押下可能かを返す
   * 次の週ボタンを押下したら未来日になってしまう場合は押下不可
   */
  public canOnNextWeek(): boolean {
    const today: Date = new Date();
    const todayNumber: number = this.$dateUtil.convertDateToNumber(today, "yyyymmdd000000000");

    let newBaseDate: Date = new Date(this.baseDate.getTime());
    newBaseDate.setDate(newBaseDate.getDate() + this.ViewDayCount);
    const newBaseDateNumber: number = this.$dateUtil.convertDateToNumber(newBaseDate, "yyyymmdd000000000");

    if (todayNumber < newBaseDateNumber) {
      return false;
    }

    return true;
  }

  /**
   * 前の週ボタン押下イベント
   * 基準日をthis.ViewDayCount分過去に更新して、画面表示に必要なプロパティを作りなおす
   */
  public async onPrevWeek(): Promise<void> {
    this.baseDate.setDate(this.baseDate.getDate() + this.ViewDayCount * -1);
    this.careimageItems = [];
    this.currentRows = this.careimageItems.length;

    await this.createView();

    return;
  }

  /**
   * 次の週ボタン押下イベント
   * 基準日をthis.ViewDayCount分未来に更新して、画面表示に必要なプロパティを作りなおす
   */
  public async onNextWeek(): Promise<void> {
    this.baseDate.setDate(this.baseDate.getDate() + this.ViewDayCount);
    this.careimageItems = [];
    this.currentRows = this.careimageItems.length;
    await this.createView();

    return;
  }

  /**
   * 今日ボタン押下イベント
   * 表示している日付を現在日付を基準に移動する
   */
  public async onToday(): Promise<void> {
    // 今日と基準日が一緒なら画面を更新する必要はない
    const today: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000");
    const baseDate: number = this.$dateUtil.convertDateToNumber(this.baseDate, "yyyymmdd000000000");

    if (today != baseDate) {
      // 基準日を更新して、画面表示に必要なプロパティを作りなおす
      this.baseDate = new Date();
      this.careimageItems = [];
      this.currentRows = this.careimageItems.length;
      await this.createView();
    }

    return;
  }

  /**
   * 介護記録のアイコン押下イベント
   * 介護記録が存在する場合は介護記録モーダルを表示する
   * 介護記録が存在しない場合は介護記録登録画面へ遷移する
   */
  public async onImageIcon(careimage: CareimageModel, name: string): Promise<void> {
    // 介護記録が存在しない場合、登録画面へ遷移する
    if (careimage.imageUrls.length <= 0) {
      const id: number = careimage.residentId;
      const date: number = careimage.datetime;
      const params: any = {
        id: `${id}`,
        date: `${date}`
      };
      this.$emit("goto-register", params);

      return;
    }

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const careimageModal: CareimageModal | Vue | Element | Vue[] | Element[] = this.$refs.careimageModal;
    if (careimageModal instanceof CareimageModal) {
      /**
       * CareimageModalコンポーネントは使いまわすコンポーネントのため、propsとして値を渡すと
       * CareimageModalの値更新タイミングよりモーダル表示が先に来てしまう可能性がある
       * そのため、モーダル表示メソッドの引数で表示する内容を渡す
       */
      const datetime: string = this.$dateUtil.convertNumberToString(careimage.datetime, "yyyy年mm月dd日", false);
      const title: string = `${datetime}の${name}様`;

      // プレビューするタイミングで介護記録画像の公開URLを作る
      // 既に作成済みであればそのまま使用し、無ければ作る
      if (!careimage.publcImageUrls) {
        careimage.publcImageUrls = [];
        for (let i = 0; i < careimage.imageUrls.length; i++) {
          const imageUrl: string = await this.getS3url(careimage.imageUrls[i]);
          careimage.publcImageUrls.push(imageUrl);
        }
      }

      careimageModal.show(title, !careimage.isPublic, careimage.publcImageUrls);

      // モーダルを経由するので、削除対象の情報は保持しておく
      this.deleteTargetString = title + "の介護記録";
      this.deleteTargetCareimage = careimage;
    }

    this.isBusy = false;

    return;
  }

  /**
   * 閲覧可能なS3のURLを取得
   *
   * @param url 元URL
   */
  public async getS3url(url: string): Promise<string> {
    const response: string = await this.s3UrlService.get(userStore, Setting.backets.imageExpireHour, url);

    return response;
  }

  /**
   * 介護記録削除ボタン押下イベント
   * 削除確認モーダルを表示する
   */
  public showDeleteConfirmModal(): void {
    this.showDeleteModal = true;

    return;
  }

  /**
   * 介護記録の削除を親コンポーネントに通知する。
   */
  public deleteCareimage(): void {
    // 介護記録モーダルを非表示にする
    const careimageModal: CareimageModal | Vue | Element | Vue[] | Element[] = this.$refs.careimageModal;
    if (careimageModal instanceof CareimageModal) {
      careimageModal.hide();
    }

    this.$emit("delete", this.deleteTargetCareimage);

    return;
  }

  /**
   * 公開中・非公開スイッチ押下イベント
   * 公開・非公開確認ダイアログを表示する
   *
   * @param careimageStatus 公開・非公開を切り替える対象の公開情報
   */
  public async onChangePublicStatus(datetime: number): Promise<void> {
    let careimageStatus: CareimageStatusModel | undefined = this.careimageStatusMap.get(datetime);

    if (careimageStatus) {
      if (careimageStatus.isPublic) {
        this.changePublicModalMessage = this.$dateUtil.convertNumberToString(careimageStatus.datetime, "yyyy年mm月dd日", false) + "の介護記録を非公開にしますか？";
      } else {
        this.changePublicModalMessage = this.$dateUtil.convertNumberToString(careimageStatus.datetime, "yyyy年mm月dd日", false) + "の介護記録を公開しますか？";
      }

      // 親コンポーネントに渡す必要があるので、更新対象の介護記録状態を保持する
      this.changeTargetCareimageStatus = careimageStatus;

      this.showUpdateModal = true;
    }

    return;
  }

  /**
   * 公開・非公開の更新を親コンポーネントに通知する。
   */
  public changePublicStatus(): void {
    this.$emit("switch", this.changeTargetCareimageStatus);

    return;
  }

  /**
   * 日付から曜日名に適用するCSSクラスを作る
   *
   * @param datetime 日時を表す数値(yyyymmddhhMMss)
   */
  public createWeekCssClass(datetime: number): string {
    const weekName: string = this.getWeek(datetime);
    const weekClass: string | undefined = this.Weeks.get(weekName);

    const holiday: string = this.$dateUtil.convertNumberToString(datetime, "yyyy-mm-dd");
    const holidayName: NationalHolidaysGetModel | undefined = this.holidaysMap.get(holiday);

    return holidayName ? "holiday" : weekClass ? weekClass : "";
  }

  /**
   * 日付から曜日名を取得する
   *
   * @param datetime 日時を表す数値(yyyymmddhhMMss)
   */
  public getWeek(datetime: number): string {
    const dateObject: Date = this.$dateUtil.convertNumberToDate(datetime);
    const weekName: string = this.$dateUtil.getWeekName(dateObject, "ja");
    return weekName;
  }

  /**
   * 日付数値から画面表示用の日付文字列へ変換する
   *
   * @param datetime 日時を表す数値(yyyymmddhhMMss)
   */
  public formatCareimageDate(datetime: number): string {
    const displayDate: string = this.$dateUtil.convertNumberToString(datetime, "mm/dd", false);
    return displayDate;
  }

  /**
   * ### 祝日名を返す
   */
  public getHolidayName(datetime: number): string | null {
    const holiday: string = this.$dateUtil.convertNumberToString(datetime, "yyyy-mm-dd");
    const holidayName: NationalHolidaysGetModel | undefined = this.holidaysMap.get(holiday);
    return holidayName ? holidayName.name : null;
  }

  /**
   * 介護記録画像の枚数で表示するアイコンを振り分ける
   * コンパイル後はstring型を返すが、TSの状態ではrequire()の戻り値を返すため、anyを設定
   *
   * @param imageUrls 介護記録画像URLの配列
   */
  public getViewIconList(careimages: Map<number, CareimageModel>, datetime: number): Array<string> {
    let imageUrls: Array<string> = [];
    const careimage: CareimageModel | undefined = careimages.get(datetime);
    if (careimage) {
      imageUrls = careimage.imageUrls;
    }

    switch (imageUrls.length) {
      case 0:
        return [require("@/assets/careimage-register.png")];
      case 1:
        return [require("@/assets/careimage-file.png")];
      case 2:
        return [require("@/assets/careimage-file.png"), require("@/assets/careimage-x2.png")];
      case 3:
        return [require("@/assets/careimage-file.png"), require("@/assets/careimage-x3.png")];
      case 4:
        return [require("@/assets/careimage-file.png"), require("@/assets/careimage-x4.png")];
      default:
        return [require("@/assets/careimage-file.png"), require("@/assets/careimage-x4.png")];
    }
  }

  /**
   * アイコンをdisableにするか否かを返す
   */
  public isViewDisableIcon(careimages: Map<number, CareimageModel>, datetime: number): boolean {
    let imageUrls: Array<string> = [];
    const careimage: CareimageModel | undefined = careimages.get(datetime);
    if (careimage) {
      imageUrls = careimage.imageUrls;
    }

    if (imageUrls.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 一括登録画面へ遷移
   */
  public gotoMultipleRegister(careimageStatus: CareimageStatusModel) {
    // 一括登録画面の表示対象を本画面と同一にするために、絞り込み情報と、ページング情報を渡す
    const startIndex: number = 0;
    const endIndex: number = this.currentRows;
    const residentGroup: string = this.filter ? String(this.filter) : "all";
    let params: any = {
      date: `${careimageStatus.datetime}`,
      start: `${startIndex}`,
      end: `${endIndex}`,
      existfamily: `${this.existFamily}`,
      residentgroup: residentGroup,
      perpage: `${this.perPage}`,
      page: `${this.currentPage}`
    };

    this.$emit("goto-multiple-register", params);

    return;
  }

  setFilterSetting() {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name + `-${this.storeNameSuffix}`, filter: this.filter });
    }
    return;
  }
}

/** テーブルの列名の情報 */
export interface CareimageTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface CareimageTableItem {
  id: number;
  name: string;
  roomName: string;
  groupId: number;
  groupName: string;
  careimages: Map<number, CareimageModel>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 公開中の介護記録のスタイル
$public-background-color: rgba(150, 210, 220, 1);

.careimage-table-component.table-box {
  .no-padding {
    padding: 15px 0 0 0 !important;
  }

  .box-header {
    .warning-message {
      margin: 10px 0 0 0;
      color: $validation-label-font-color;
    }
    .error-message {
      margin: 10px 0 0 0;
    }
    .buttons {
      text-align: center;
      // ボタンを横並びにさせるための設定
      display: inline-block;
      .btn {
        margin: 0 0 0 12px;
        width: 104px;
      }
    }
  }

  .box-body {
    .multiple-register-btn {
      font-size: 16px !important;
      padding: 4px 8px 4px 8px !important;
      height: 32px !important;
    }
    .careimage-date {
      font-weight: normal;
      padding: 2px;
      vertical-align: middle;
      .week {
        font-size: 14px;
        line-height: 18px;
      }
      .date {
        font-size: 16px;
      }
      // 介護記録一覧画面では、強調する曜日の文字サイズは少し大きくする
      .saturday,
      .sunday {
        font-size: 16px;
      }
    }
    .resident-name {
      .room-name {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .name {
        font-size: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .careimage-icon {
      &:hover {
        background-color: $list-hover;
      }
      .icon:hover {
        cursor: pointer;
      }
      .disable-icon:hover {
        cursor: not-allowed;
      }
    }
  }
}
</style>
